if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButton.removeAttribute('aria-haspopup');
      this.successMessage = this.createSuccessMessage(this.querySelector('.sk-card-quantity') || this.submitButton);
      this.form.addEventListener('change', () => { this.successMessage.replaceChildren(); this.handleErrorMessage(); });

      const quantitySelect = this.form.querySelector('[data-sk-quantity-select]');
      if (quantitySelect) {
        quantitySelect.addEventListener('change', () => {
          if (quantitySelect.value !== 'custom') return;
          const quantityInput = this.form.querySelector('[data-sk-custom-quantity]');
          quantitySelect.disabled = true;
          quantitySelect.hidden = true;
          quantitySelect.removeAttribute('name');
          quantityInput.name = 'quantity';
          quantityInput.disabled = false;
          quantityInput.hidden = false;
          quantityInput.closest('.sk-card-quantity').querySelector('label').htmlFor = quantityInput.id;
          quantityInput.focus();
          quantityInput.select();
        });
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.error = false;
      this.successMessage.replaceChildren();

      const quantityInput = this.form.elements.namedItem('quantity');
      if (quantityInput instanceof HTMLInputElement && !quantityInput.checkValidity()) {
        quantityInput.reportValidity();
        return;
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            if (this.cart?.refreshContents) {
              try {
                await this.cart.refreshContents();
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
              } catch (error) { console.error(error); }
            }
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.cart.renderContents(response, false);
          this.showSuccessMessage(this.successMessage);
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            const opener = document.querySelector(`.product-card__container > modal-opener[data-modal="#${CSS.escape(quickAddModal.id)}"]`);
            if (opener) this.showSuccessMessage(this.createSuccessMessage(opener));
            quickAddModal.hide(true);
          }
        })
        .catch(async (e) => {
          console.error(e);
          if (this.cart?.refreshContents) {
            try {
              await this.cart.refreshContents();
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            } catch (error) { console.error(error); }
          }
          if (!this.successMessage.textContent) this.handleErrorMessage(window.cartStrings.error);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    createSuccessMessage(anchor) {
      const previous = anchor.previousElementSibling;
      if (previous?.classList.contains('sk-cart-added')) return previous;
      const status = document.createElement('div');
      status.className = 'sk-cart-added';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      anchor.before(status);
      return status;
    }

    showSuccessMessage(status) {
      const check = document.createElement('span');
      check.className = 'sk-cart-added__check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';
      status.replaceChildren(check, document.createTextNode(window.cartStrings.itemAdded));
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        status.animate([{ opacity: 0, transform: 'translateY(3px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'ease-out' });
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.update.bind(this));
    this.update();
    document.querySelector('footer').classList.add('sticky-cart-modal_bottom_padding');
  }
  update(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
	const addButton = button.querySelector('[name="add"]');
    const rangeToShowModal = this.getTop(addButton) + button.clientHeight;
    if(window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')){
      this.classList.add('show-modal');
      document.querySelector('body').classList.add('modal__sticky-cart');
    }
    if(window.scrollY < rangeToShowModal && this.classList.contains('show-modal')){
      this.classList.remove('show-modal');
      document.querySelector('body').classList.remove('modal__sticky-cart');
    }
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);
